import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../style.css';

function About() {
  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Sobre Nosotros | Culturlingua Tlaquepaque</title>
        <meta name="description" content="Conoce Culturlingua, más de 20 años de experiencia enseñando inglés en Tlaquepaque, Jalisco." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Nuestra Historia</div>
        <h1>Sobre Nosotros</h1>
        <p>Más de 20 años formando hablantes reales en Tlaquepaque, Jalisco.</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'800px', margin:'0 auto', display:'flex', flexDirection:'column', gap:'32px'}}>

          <div style={{background:'white', borderRadius:'20px', padding:'40px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)'}}>
            <div className="section-tag">Quiénes somos</div>
            <h2 className="section-headline" style={{fontSize:'1.8rem', marginBottom:'16px'}}>Culturlingua Tlaquepaque</h2>
            <p style={{color:'var(--muted)', lineHeight:'1.8', marginBottom:'16px'}}>
              Culturlingua es un instituto ubicado en el centro de Tlaquepaque con más de 20 años de experiencia
              en la enseñanza del inglés a estudiantes de habla hispana, así como la impartición de clases de
              español para personas nativas de otro idioma.
            </p>
            <p style={{color:'var(--muted)', lineHeight:'1.8'}}>
              Culturlingua Tlaquepaque es un miembro orgulloso de la Cadena Culturlingua con sedes en diferentes
              ciudades, ofreciendo sus servicios desde el año 2004.
            </p>
          </div>

          <div style={{background:'white', borderRadius:'20px', padding:'40px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)'}}>
            <div className="section-tag">Lo que nos diferencia</div>
            <h2 className="section-headline" style={{fontSize:'1.8rem', marginBottom:'16px'}}>¿Por qué Culturlingua?</h2>
            <p style={{color:'var(--muted)', lineHeight:'1.8', marginBottom:'16px'}}>
              Nos preocupamos por nuestros estudiantes. Nuestros maestros son profesionales y calificados, y usan
              toda su experiencia, conocimientos y herramientas para asegurarse de que los alumnos aprendan de
              la manera más amena, divertida y dinámica posible.
            </p>
            <p style={{color:'var(--muted)', lineHeight:'1.8'}}>
              La experiencia de más de 20 años nos permite ofrecer programas de calidad basados en un sistema de
              enseñanza diferente, fundamentado en la experiencia profesional de nuestros maestros.
            </p>
          </div>

          <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'20px'}}>
            {[
              ['20+', 'Años de experiencia', '🏛️'],
              ['300+', 'Alumnos activos', '🎓'],
              ['100%', 'Profesores certificados', '✅'],
            ].map(([num, label, icon]) => (
              <div key={label} style={{background:'var(--navy)', borderRadius:'16px', padding:'28px', textAlign:'center'}}>
                <div style={{fontSize:'2rem', marginBottom:'8px'}}>{icon}</div>
                <div style={{fontFamily:'Fraunces, serif', fontSize:'2rem', fontWeight:'900', color:'var(--gold)', lineHeight:'1'}}>{num}</div>
                <div style={{color:'rgba(255,255,255,0.6)', fontSize:'0.85rem', marginTop:'6px'}}>{label}</div>
              </div>
            ))}
          </div>

          <div style={{textAlign:'center', paddingTop:'16px'}}>
            <Link to="/contacto" className="btn-glow">Contáctanos →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
